import { render, staticRenderFns } from "./VuxTabpanelItemComponent.vue?vue&type=template&id=69862fcb&"
import script from "./VuxTabpanelItemComponent.vue?vue&type=script&lang=js&"
export * from "./VuxTabpanelItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./VuxTabpanelItemComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports